import React from "react";
import { Link } from "react-router-dom";
import ScrollReveal from "../components/ScrollReveal";
import { getCopy, getCopyObject } from "../utils/copyUtils";

const NotFoundPage: React.FC = () => {
  // Get copy from JSON file
  const hero = getCopyObject<{ title: string; description: string }>("not_found.hero");
  const content = getCopyObject<{ title: string; description: string; back_button: string }>("not_found.content");

  return (
    <>
      {/* Hero Section */}
      <section className="hero">
        <div className="container">
          <ScrollReveal className="hero-content" direction="up" delay={200}>
            <h1 className="hero-title">{hero?.title}</h1>
            <p className="hero-description">{hero?.description}</p>
          </ScrollReveal>
        </div>
      </section>

      <main className="main">
        <div className="main__curved curved-ellipse"></div>
        <div className="main__curved-line curved-ellipse"></div>

        {/* Not Found Section */}
        <section className="not-found">
          <div className="container">
            <ScrollReveal direction="up" delay={300}>
              <div className="not-found-content">
                <h2 className="not-found-title">{content?.title}</h2>
                <p className="not-found-text">{content?.description}</p>
                <Link to="/" className="btn btn-primary">
                  {content?.back_button}
                </Link>
              </div>
            </ScrollReveal>
          </div>
        </section>
      </main>
    </>
  );
};

export default NotFoundPage;
